import React, { useEffect, useState } from 'react';
import { API, Auth } from 'aws-amplify';
import { useLocation } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './SaggitaMng.css';

type HomeProps = {
  activeLink: VoidFunction;
};

type ParamState = {
  id: string;
}

const chList = ['A1', 'A2', 'A3', 'B1', 'B2', 'B3', 'C1', 'C2', 'C3'];

const CH_NAMES_VALID_ClASS = 'form-control m-0 pt-1 pb-1 is-valid';
const CH_NAMES_INVALID_ClASS = 'form-control m-0 pt-1 pb-1 is-invalid';

const NUM_AS_VALID_ClASS = 'form-control m-0 is-valid';
const NUM_AS_INVALID_ClASS = 'form-control m-0 is-invalid';

const NUM_BS_VALID_ClASS = 'form-control m-0 is-valid';
const NUM_BS_INVALID_ClASS = 'form-control m-0 is-invalid';

const ALARM_UPPERS_VALID_ClASS = 'form-control m-0 is-valid';
const ALARM_UPPERS_INVALID_ClASS = 'form-control m-0 is-invalid';

const ALARM_LOWERS_VALID_ClASS = 'form-control m-0 is-valid';
const ALARM_LOWERS_INVALID_ClASS = 'form-control m-0 is-invalid';

const ALARM_MAIL_LIST_VALID_ClASS = 'form-control m-0 is-valid';
const ALARM_MAIL_LIST_INVALID_ClASS = 'form-control m-0 pt-1 pb-0 is-invalid';

type validColumType = {
  [key: string]: boolean;
}

const validColum : validColumType = {
  saggitaName: true,
  chNames: true,
  numAs: true,
  numBs: true,
  alarmLowers: true,
  alarmUppers: true,
  mailAddressList: true
}


const SaggitaMng: React.FC<HomeProps> = (props) =>{
  const [saggitaName, setSaggitaName] = useState('');
  const [chNames, setChNames] = useState(['','','','','','','','','']);
  const [units, setUnits] = useState(['1','1','1','1','1','1','1','1','1']);
  const [numAs, setNumAs] = useState(['1','1','1','1','1','1','1','1','1']);
  const [numBs, setNumBs] = useState(['0','0','0','0','0','0','0','0','0']);
  const [alarmLowers, setAlarmLowers] = useState(['0','0','0','0','0','0','0','0','0']);
  const [alarmUppers, setAlarmUppers] = useState(['0','0','0','0','0','0','0','0','0']);
  const [alarmMailList, setAlarmMailList] = useState(['']);
  const [errorText, setErrorText] = useState('');
  const [alertClass, setAlertClass] = useState('alert alert-danger d-none');
  const [btnupdateDisabled, setBtnupdateDisabled] = useState(false);

  const [saggitaNameClass, setSaggitaNameClass] = useState('form-control m-0 pt-1 pb-1 is-valid');
  const [chNamesClass, setChNamesClass] = useState([
    CH_NAMES_VALID_ClASS, CH_NAMES_VALID_ClASS, CH_NAMES_VALID_ClASS, // A
    CH_NAMES_VALID_ClASS, CH_NAMES_VALID_ClASS, CH_NAMES_VALID_ClASS, // B
    CH_NAMES_VALID_ClASS, CH_NAMES_VALID_ClASS, CH_NAMES_VALID_ClASS  // C
  ]);
  const [numAsClass, setNumAsClass] = useState([
    NUM_AS_VALID_ClASS, NUM_AS_VALID_ClASS, NUM_AS_VALID_ClASS, // A
    NUM_AS_VALID_ClASS, NUM_AS_VALID_ClASS, NUM_AS_VALID_ClASS, // B
    NUM_AS_VALID_ClASS, NUM_AS_VALID_ClASS, NUM_AS_VALID_ClASS  // C
  ]);
  const [numBsClass, setNumBsClass] = useState([
    NUM_BS_VALID_ClASS, NUM_BS_VALID_ClASS, NUM_BS_VALID_ClASS, // A
    NUM_BS_VALID_ClASS, NUM_BS_VALID_ClASS, NUM_BS_VALID_ClASS, // B
    NUM_BS_VALID_ClASS, NUM_BS_VALID_ClASS, NUM_BS_VALID_ClASS  // C
  ]);
  const [alarmUppersClass, setAlarmUppersClass] = useState([
    ALARM_UPPERS_VALID_ClASS, ALARM_UPPERS_VALID_ClASS, ALARM_UPPERS_VALID_ClASS, // A
    ALARM_UPPERS_VALID_ClASS, ALARM_UPPERS_VALID_ClASS, ALARM_UPPERS_VALID_ClASS, // B
    ALARM_UPPERS_VALID_ClASS, ALARM_UPPERS_VALID_ClASS, ALARM_UPPERS_VALID_ClASS  // C
  ]);
  const [alarmLowersClass, setAlarmLowersClass] = useState([
    ALARM_LOWERS_VALID_ClASS, ALARM_LOWERS_VALID_ClASS, ALARM_LOWERS_VALID_ClASS, // A
    ALARM_LOWERS_VALID_ClASS, ALARM_LOWERS_VALID_ClASS, ALARM_LOWERS_VALID_ClASS, // B
    ALARM_LOWERS_VALID_ClASS, ALARM_LOWERS_VALID_ClASS, ALARM_LOWERS_VALID_ClASS  // C
  ]);
  const [alarmMailListClass, setAlarmMailListClass] = useState([ALARM_MAIL_LIST_VALID_ClASS]);

  const [numAsNgMsg, setNumAsNgMsg] = useState([
    "NG", "NG", "NG","NG", "NG", "NG","NG", "NG", "NG"
  ]);
  const [numBsNgMsg, setNumBsNgMsg] = useState([
    "NG", "NG", "NG","NG", "NG", "NG","NG", "NG", "NG"
  ]);
  const [alarmUppersNgMsg, setAlarmUppersNgMsg] = useState([
    "NG", "NG", "NG","NG", "NG", "NG","NG", "NG", "NG"
  ]);
  const [alarmLowersNgMsg, setAlarmLowersNgMsg] = useState([
    "NG", "NG", "NG","NG", "NG", "NG","NG", "NG", "NG"
  ]);

  const location = useLocation();
  const param = location.state as ParamState;

  const unitOptions = [
    { value: 1, label: 'V'},
    { value: 2, label: 'A'},
    { value: 3, label: 'Ω'}
  ];

  let initFlg = false;
  useEffect(() => {
    if (initFlg === false) {
      getSampleData();
      props.activeLink();
      initFlg = true;
    }
  }, []);

  const isValid = () => {
    let valid = false;

    for (let key in validColum) {
      let value = validColum[key];
      if (value === false) {
        valid = true;
        break;
      }
    }

    return valid;
  }

  const getSampleData = async () => {
    try {
      const apiName = 'MainApi';
      const path = '/saggita/' + param.id;
      const myInit = {
        headers: { 
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
        },
      };
    
      const resp = await API.get(apiName, path, myInit);

      setSaggitaName(resp.saggita.name);

      const alarmMails = [] as any[];
      const alarmMailsClass = [] as any[];

      if (resp.saggita.alarmMailList !== undefined) {
        if (resp.saggita.alarmMailList.length > 0) {
          resp.saggita.alarmMailList.forEach((data: any) => {
            alarmMails.push(data);
            alarmMailsClass.push(ALARM_MAIL_LIST_VALID_ClASS);
          });
          setAlarmMailList(alarmMails);
          setAlarmMailListClass(alarmMailsClass);
        }
      }

      if (resp.channel.length > 0) {
        const chNameList = [] as any[];
        const unitList = [] as any[];
        const numAList = [] as any[];
        const numBList = [] as any[];
        const alarmLowerList = [] as any[];
        const alarmUpperList = [] as any[];

        chList.forEach((ch) => {
          let findFlg = false;
          resp.channel.forEach((data: any) => {
            if (data.groupType === ch) {
              chNameList.push(data.name);
              unitList.push(data.unit);
              numAList.push(data.numA);
              numBList.push(data.numB);
              alarmLowerList.push(data.alarmLower);
              alarmUpperList.push(data.alarmUpper);
              findFlg = true;
            }
          });

          if (!findFlg) {
            chNameList.push("");
            unitList.push("");
            numAList.push("");
            numBList.push("");
            alarmLowerList.push("");
            alarmUpperList.push("");
          }
      });

        setChNames(chNameList);
        setUnits(unitList);
        setNumAs(numAList);
        setNumBs(numBList);
        setAlarmLowers(alarmLowerList);
        setAlarmUppers(alarmUpperList);
      }
    }
    catch (err) {
      console.log('error getting data')
      setAlertMessage('AG02001 データの取得に失敗しました。');
    }
  }

  const setAlertMessage = (message: string) => {
    setErrorText(message);
    setAlertClass('alert alert-danger');
  }

  const handleChangeSaggitaName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSaggitaName(e.target.value);
  }

  const handleChangeChName = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newChNames = chNames.concat();
    newChNames[index] = e.target.value;
    setChNames(newChNames);
  }

  const handleChangeUnit = (e: React.ChangeEvent<HTMLSelectElement>, index: number) => {
    const newUnits = units.concat();
    newUnits[index] = e.target.value;
    setUnits(newUnits);
  }

  const handleChangeNumA = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newNumAs = numAs.concat();
    newNumAs[index] = e.target.value;
    setNumAs(newNumAs);

    let value = Number(e.target.value);

    const newNumAsClass = numAsClass.concat();
    const newNumAsNgMsg = numAsNgMsg.concat();

    if (isNaN(value)) {
      newNumAsClass[index] = ALARM_UPPERS_INVALID_ClASS;
      newNumAsNgMsg[index] = "NG 数値のみ";
      validColum.numA = false;
    }
    else {
      newNumAsClass[index] = ALARM_UPPERS_VALID_ClASS;
      newNumAsNgMsg[index] = "OK";
      validColum.numA = true;
    }

    setNumAsClass(newNumAsClass);
    setNumAsNgMsg(newNumAsNgMsg);

    setBtnupdateDisabled(isValid());
  }

  const handleChangeNumB = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newNumBs = numBs.concat();
    newNumBs[index] = e.target.value;
    setNumBs(newNumBs);

    let value = Number(e.target.value);

    const newNumBsClass = numBsClass.concat();
    const newNumBsNgMsg = numBsNgMsg.concat();

    if (isNaN(value)) {
      newNumBsClass[index] = NUM_BS_INVALID_ClASS;
      newNumBsNgMsg[index] = "NG 数値のみ";
      validColum.numB = false;
    }
    else {
      newNumBsClass[index] = NUM_BS_VALID_ClASS;
      newNumBsNgMsg[index] = "OK";
      validColum.numB = true;
    }

    setNumBsClass(newNumBsClass);
    setNumBsNgMsg(newNumBsNgMsg);

    setBtnupdateDisabled(isValid());
  }

  const handleChangeAlarmLower = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    let upperValue = alarmUppers[index];
    let lowerValue = e.target.value;

    const newAlarmLowers = alarmLowers.concat();
    newAlarmLowers[index] = lowerValue;
    setAlarmLowers(newAlarmLowers);

    let numUpperValue = Number(upperValue);
    let numLowerValue = Number(lowerValue);

    alarmCheck(numLowerValue, numUpperValue, index);
  }
  const setAlarmLowersOK = (msg: string, index: number) => {
    const newAlarmLowersClass = alarmLowersClass.concat();
    const newAlarmLowersNgMsg = alarmLowersNgMsg.concat();

    newAlarmLowersClass[index] = ALARM_LOWERS_VALID_ClASS;
    newAlarmLowersNgMsg[index] = msg;

    setAlarmLowersClass(newAlarmLowersClass);
    setAlarmLowersNgMsg(newAlarmLowersNgMsg);
  }
  const setAlarmLowersNG = (msg: string, index: number) => {
    const newAlarmLowersClass = alarmLowersClass.concat();
    const newAlarmLowersNgMsg = alarmLowersNgMsg.concat();

    newAlarmLowersClass[index] = ALARM_LOWERS_INVALID_ClASS;
    newAlarmLowersNgMsg[index] = msg;

    setAlarmLowersClass(newAlarmLowersClass);
    setAlarmLowersNgMsg(newAlarmLowersNgMsg);
  }

  const handleChangeAlarmUpper = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    let upperValue = e.target.value;
    let lowerValue = alarmLowers[index];

    const newAlarmUppers = alarmUppers.concat();
    newAlarmUppers[index] = upperValue;
    setAlarmUppers(newAlarmUppers);

    let numUpperValue = Number(upperValue);
    let numLowerValue = Number(lowerValue);

    alarmCheck(numLowerValue, numUpperValue, index);
  }
  const alarmCheck = (lower: number, upper: number, index: number) => {
    let lowerValid = true;
    let upperValid = true;

    // upper: 数値以外はNG.
    if (isNaN(upper)) {
      setAlarmUppersNG("NG 数値のみ", index);
      upperValid = false;
    }
    // lower: 数値以外はNG.
    if (isNaN(lower)) {
      setAlarmLowersNG("NG 数値のみ", index);
      lowerValid = false;
    }

    if (upperValid && lowerValid) {
      // 上限値より下限値の方が大きい場合はNG.
      if (upper < lower) {
        setAlarmUppersNG("NG 上限＜下限", index);
        upperValid = false;

        setAlarmLowersNG("NG 上限＜下限", index);
        lowerValid = false;
      }
    }

    if (upperValid) {
      setAlarmUppersOK("OK", index);
    }
    if (lowerValid) {
      setAlarmLowersOK("OK", index);
    }

    validColum.upper = upperValid;
    validColum.lower = lowerValid;

    setBtnupdateDisabled(isValid());
  }
  const setAlarmUppersOK = (msg: string, index: number) => {
    const newAlarmUppersClass = alarmUppersClass.concat();
    const newAlarmUppersNgMsg = alarmUppersNgMsg.concat();

    newAlarmUppersClass[index] = ALARM_UPPERS_VALID_ClASS;
    newAlarmUppersNgMsg[index] = msg;

    setAlarmUppersClass(newAlarmUppersClass);
    setAlarmUppersNgMsg(newAlarmUppersNgMsg);
  }
  const setAlarmUppersNG = (msg: string, index: number) => {
    const newAlarmUppersClass = alarmUppersClass.concat();
    const newAlarmUppersNgMsg = alarmUppersNgMsg.concat();

    newAlarmUppersClass[index] = ALARM_UPPERS_INVALID_ClASS;
    newAlarmUppersNgMsg[index] = msg;

    setAlarmUppersClass(newAlarmUppersClass);
    setAlarmUppersNgMsg(newAlarmUppersNgMsg);
  }

  const handleChangeAlarmMail = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newAlarmMailList = alarmMailList.concat();
    newAlarmMailList[index] = e.target.value;
    setAlarmMailList(newAlarmMailList);
  }

  const handleClickBtnAddMail = () => {
    const newAlarmMailList = alarmMailList.concat();
    newAlarmMailList.push('');
    setAlarmMailList(newAlarmMailList);

    const newAlarmMailListClass = alarmMailListClass.concat();
    newAlarmMailListClass.push(ALARM_MAIL_LIST_VALID_ClASS);
    setAlarmMailListClass(newAlarmMailListClass);
  }

  const handleClickBtnUpdate = async () => {
    const saggitadata = {
      saggitaId: param.id,
      name: saggitaName,
      alarmMailList: alarmMailList
    };

    const chdatas = [] as any[];
    chList.forEach((data, index) => {
      const chdata = {
        groupType: data,
        name: chNames[index],
        numA: numAs[index],
        numB: numBs[index],
        unit: units[index],
        alarmLower: alarmLowers[index],
        alarmUpper: alarmUppers[index]
      };

      chdatas.push(chdata);
    });

    const bodydata = {
      saggita: saggitadata,
      channel: chdatas
    };

    try {
      const apiName = 'MainApi';
      const path = '/saggita';
      const myInit = {
        headers: { 
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
        },
        body: bodydata
      };
    
      await API.put(apiName, path, myInit);

      setErrorText('データを更新しました。');
      setAlertClass('alert alert-success');
      }
    catch (err) {
      console.log('error getting data')
      setAlertMessage('AG02002 データの更新に失敗しました。');
    }
  }

  const chClassTile = 'pt-3 m-0';
  const chClassInput = 'm-0';

  return (
    <div className="p-3">
      <div className={alertClass} role="alert">{errorText}</div>
      <h4>通信ユニットの編集</h4>
      <p className='m-0 p-0'>{param.id}</p>
      <table className="table table-borderless text-nowrap m-0 p-0" style={{'width': '1450px'}}>
        <tbody>
          <tr>
            <td className='pt-3 m-0' style={{'width': '60px'}}>機体名称</td>
            <td>
              <div className='form-group'>
                <input type="text" className={saggitaNameClass} style={{'width': '200px'}} id="saggitaName" value={saggitaName} placeholder='機体名称' onChange={(e) => handleChangeSaggitaName(e)}></input>
              </div>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <p className='m-0 p-0'>CH設定値</p>
      <table className="table table-borderless text-nowrap m-0 p-0" style={{'width': '1570px'}}>
        <tbody>
          {
            chList.map((data, index) => (
              <tr key={'chtr' + index}>
                <td className={chClassTile} style={{'width': '30px'}}>{data}</td>
                <td className={chClassInput} style={{'width': '220px'}}>
                  <div className='form-group m-0 p-0'>
                      <input type="text" style={{'width': '200px'}} className={chNamesClass[index]} id={data + 'name'} key={'name' + index} value={chNames[index]} placeholder='CH名称' onChange={(e) => handleChangeChName(e, index)}></input>
                      <div className="valid-feedback">
                        OK
                      </div>
                      <div className="invalid-feedback">
                        NG
                      </div>
                  </div>
                </td>
                <td className={chClassTile} style={{'width': '50px'}}>単位</td>
                <td className={chClassInput} style={{'width': '80px'}}>
                  <div className='form-group m-0 p-0'>
                    <select className='custom-select' id={data + 'unit'} key={'unit' + index} value={units[index]} onChange={(e) => handleChangeUnit(e, index)}>
                      {unitOptions.map((d, i) => <option key={i} value={d.value}>{d.label}</option>)}
                    </select>
                  </div>
                </td>
                <td style={{'width': '60px'}}></td>
                <td className={chClassTile} style={{'width': '90px'}}>換算値</td>
                <td className={chClassTile} style={{'width': '20px'}}>倍率</td>
                <td className={chClassInput} style={{'width': '150px'}}>
                  <div className='form-group m-0 p-0'>
                    <input type="text" style={{'width': '130px'}} className={numAsClass[index]} id={data + 'numa'} key={'numa' + index} value={numAs[index]} placeholder='倍率' onChange={(e) => handleChangeNumA(e, index)}></input>
                    <div className="valid-feedback">
                      OK
                    </div>
                    <div className="invalid-feedback">
                      {numAsNgMsg[index]}
                    </div>
                  </div>
                </td>
                <td className={chClassTile} style={{'width': '20px'}}>切片</td>
                <td className={chClassInput} style={{'width': '150px'}}>
                  <div className='form-group m-0 p-0'>
                    <input type="text" style={{'width': '130px'}} className={numBsClass[index]} id={data + 'numb'} key={'numb' + index} value={numBs[index]} placeholder='切片' onChange={(e) => handleChangeNumB(e, index)}></input>
                    <div className="valid-feedback">
                      OK
                    </div>
                    <div className="invalid-feedback">
                      {numBsNgMsg[index]}
                    </div>
                </div>
                </td>
                <td style={{'width': '60px'}}></td>
                <td className={chClassTile} style={{'width': '100px'}}>非警報範囲</td>
                <td className={chClassTile} style={{'width': '50px'}}>上限</td>
                <td className={chClassInput} style={{'width': '150px'}}>
                  <div className='form-group m-0 p-0'>
                    <input type="text" style={{'width': '130px'}} className={alarmUppersClass[index]} id={data + 'jougen'} key={'alarmupper' + index} value={alarmUppers[index]} placeholder='上限' onChange={(e) => handleChangeAlarmUpper(e, index)}></input>
                    <div className="valid-feedback">
                      OK
                    </div>
                    <div className="invalid-feedback">
                      {alarmUppersNgMsg[index]}
                    </div>
                  </div>
                </td>
                <td className={chClassTile} style={{'width': '50px'}}>下限</td>
                <td className={chClassInput} style={{'width': '120px'}}>
                  <div className='form-group m-0 p-0'>
                    <input type="text" style={{'width': '130px'}} className={alarmLowersClass[index]} id={data + 'kagen'} key={'alarmlower' + index} value={alarmLowers[index]} placeholder='下限' onChange={(e) => handleChangeAlarmLower(e, index)}></input>
                    <div className="valid-feedback">
                      OK
                    </div>
                    <div className="invalid-feedback">
                      {alarmLowersNgMsg[index]}
                    </div>
                  </div>
                </td>
                <td className=''></td>
              </tr>
            ))
          }
        </tbody>
      </table>
      <p className='m-0 p-0 mt-4'>警報メール宛先</p>
      <table className="table table-borderless text-nowrap m-0 p-0" style={{'width': '1200px'}}>
        <tbody>
          {
            alarmMailList.map((data, index) => (
              <tr key={'mailtr' + index}>
                <td key={'mailtdlabel' + index} className='pt-1 pb-0 m-0' style={{'width': '60px'}}>メールアドレス</td>
                <td key={'mailtdvalue' + index} className='pt-1 pb-0 m-0'>
                  <div key={'maildivvalue' + index} className='form-group'>
                    <input type="text" className={alarmMailListClass[index]} style={{'width': '300px'}} id={"mailaddress" + index} key={"mailaddress" + index} value={data} placeholder='メールアドレス' onChange={(e) => handleChangeAlarmMail(e, index)}></input>
                    <div className="valid-feedback">
                      OK
                    </div>
                    <div className="invalid-feedback">
                      NG
                    </div>
                  </div>
                </td>
                <td key={'mailtdwork' + index} className='pt-1 pb-0 m-0'></td>
              </tr>
            ))
          }
        </tbody>
      </table>
      <div className='form-group m-0 p-0 mb-1'>
        <input type="button" className='btn btn-info' id="btnaddmail" value={'＋'} onClick={() => handleClickBtnAddMail()}></input>
      </div>
      <div className='form-group m-0 p-0 '>
        <input type="button" className='btn btn-primary' id="btnupdate" value={'更新'} onClick={() => handleClickBtnUpdate()} disabled={btnupdateDisabled}></input>
      </div>
    </div>
  );
}

export default SaggitaMng;
